"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

/**
 * Bannière affichée quand l'abonnement de la team a expiré ou quand le paiement est en attente
 * Affiche un message d'avertissement avec un bouton pour réactiver/payer
 *
 * @param {Object} props
 * @param {string} props.status - Le statut de l'abonnement ("canceled" ou "past_due")
 */
export function SubscriptionExpiredBanner({ status = "canceled" }) {
    const t = useTranslations("teamsDashboard");

    const isPastDue = status === "past_due";

    return (
        <div className={`bg-gradient-to-r ${isPastDue ? "from-red-500 to-rose-500 shadow-red-500/20" : "from-orange-500 to-amber-500 shadow-orange-500/20"} rounded-2xl p-4 mb-6 shadow-lg`}>
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
                        <SolarIcon name="danger-triangle-linear" className="w-5 h-5 text-white" />
                    </div>
                    <div>
                        <h3 className="text-white font-semibold text-sm sm:text-base">
                            {isPastDue ? t("subscriptionPastDueBanner") : t("subscriptionExpiredBanner")}
                        </h3>
                        <p className="text-white/80 text-xs sm:text-sm mb-0">
                            {isPastDue ? t("subscriptionPastDueDescription") : t("subscriptionExpiredDescription")}
                        </p>
                    </div>
                </div>
                <Link
                    href="/teams/dashboard/settings"
                    className={`flex items-center gap-2 px-4 py-2.5 bg-white ${isPastDue ? "text-red-600 hover:bg-red-50" : "text-orange-600 hover:bg-orange-50"} rounded-xl transition-all text-sm font-semibold whitespace-nowrap shadow-sm btn-3d`}
                >
                    <SolarIcon name="card-linear" className="w-4 h-4" />
                    {isPastDue ? t("payNow") : t("reactivateNow")}
                </Link>
            </div>
        </div>
    );
}
